import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IVendorCompanyMast } from "../../models/VendorCompanyMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

interface IProps {
    open: boolean;
    onHide: () => void;
    singleData: IVendorCompanyMast;
    toast: any;
}

export interface IVendorAccountDetailsList {
    account_Person_ID?: number;
    vendor_Company_ID?: number;
    vendor_Company_Name?: string;
    account_Person_Name: string;
    account_Person_Email: string;
    account_Person_Desk: string;
    account_Person_Cell?: string | null;
    addedBy?: string,
    added_On?: Date,
}

export interface IVendorAccountDetails {
    account_Person_ID?: number;
    vendor_Company_ID?: number;
    account_Person_Name: string;
    account_Person_Email: string;
    account_Person_Desk: string;
    account_Person_Cell?: string | null;
}

const schema = yup.object({
    vendor_Company_ID: yup.number().nullable(),
    account_Person_Name: yup.string().required("Account Person Name is required*"),
    account_Person_Email: yup.string().required("Account Person Email is required*").email("Account Person Email must be a valid email"),
    account_Person_Desk: yup.string().nullable(),
    account_Person_Cell: yup.string().required("Cell Phone is required*"),
});

export const CompanyAccountsDetails = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVendorAccountDetailsList>, loading: boolean });
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IVendorAccountDetails>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = async (data: IVendorAccountDetails) => {
        setLoading(true);
        let newData: IVendorAccountDetails = data;
        newData.vendor_Company_ID = props.singleData.vendor_Company_ID || 0;
        const response = await Fetch("Vendor_Company_Mast/saveAccountDetails", (newData.account_Person_ID !== null && newData.account_Person_ID !== undefined && newData.account_Person_ID !== 0) ? "PUT" : "POST", newData, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Select the State First.", life: 3000 });
            reset({
                vendor_Company_ID: 0,
                account_Person_Name: "",
                account_Person_Email: "",
                account_Person_Desk: "",
                account_Person_Cell: "",
            });
            loadTableData(props.singleData.vendor_Company_ID || 0);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    const onHide = () => {
        setLoading(false);
        reset({
            vendor_Company_ID: 0,
            account_Person_Name: "",
            account_Person_Email: "",
            account_Person_Desk: "",
            account_Person_Cell: "",
        });
        setTableData({ tableData: [], loading: false });
        props.onHide();
    };

    const removeDetails = async (rowData: IVendorAccountDetailsList) => {
        const response = await Fetch("Vendor_Company_Mast/removeAccountDetails", "DELETE", null, `account_Person_ID=${rowData.account_Person_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Account Person Details Removed Successfully.", life: 3000 });
            loadTableData(props.singleData.vendor_Company_ID || 0);
        } else {
            props.toast.current.show({ severity: 'error', detail: "Failed to Remove Account Person Details.", life: 3000 });
        }
    }

    const rejectFunc = () => {
    };

    const removeDetailsDetails = (rowData: IVendorAccountDetailsList) => {
        confirmDialog({
            message: `Are you sure you want to remove accounts details?`,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => removeDetails(rowData),
            reject: () => rejectFunc()
        });
    }

    const actionBodyTemplate = (rowData: IVendorAccountDetails) => {
        const data: IVendorAccountDetails = {
            account_Person_ID: rowData.account_Person_ID,
            vendor_Company_ID: rowData.vendor_Company_ID,
            account_Person_Name: rowData.account_Person_Name,
            account_Person_Email: rowData.account_Person_Email,
            account_Person_Desk: rowData.account_Person_Desk,
            account_Person_Cell: rowData.account_Person_Cell,
        }
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => reset(data)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text mr-1" style={{ color: "red" }} onClick={() => removeDetailsDetails(data)} />
            </div>
        );
    };

    const loadTableData = async (companyID: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const repsonse = await Fetch("Vendor_Company_Mast/getAccountDetails", "GET", null, `companyID=${companyID}`, props.toast);
        if (repsonse) {
            const data: Array<IVendorAccountDetailsList> = await repsonse.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    useEffect(() => {
        if (props.open && props.singleData.vendor_Company_ID) {
            loadTableData(props.singleData.vendor_Company_ID);
        }
    }, [props.open]);
    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Client Company" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                    <JVInput column={3} required label="Accounts Person Name" control={control} name="account_Person_Name" error={errors.account_Person_Name?.message} />
                    <JVInput column={3} required label="Account Person Email" control={control} name="account_Person_Email" error={errors.account_Person_Email?.message} />
                    <JVInputMask column={3} mask="(999) 999-9999" required label="Cell No" control={control} name="account_Person_Cell" error={errors.account_Person_Cell?.message} />
                    <JVInputMask column={3} mask="(999) 999-9999" label="Desk No" control={control} name="account_Person_Desk" error={errors.account_Person_Desk?.message} />

                    <div style={{ marginBottom: '20px', width: '100%' }}></div>

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                        <Button style={{ width: '100px' }} label="CLEAR" onClick={() => reset({
                            vendor_Company_ID: 0,
                            account_Person_Name: "",
                            account_Person_Email: "",
                            account_Person_Desk: "",
                            account_Person_Cell: "",
                        })} type="button" className="p-button-outlined surface-200"></Button>
                    </div>
                </form>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData} lazy dataKey="id"
                    emptyMessage="No Persons found."
                    header={<></>}
                    loading={tableData.loading}
                >
                    <Column field="account_Person_Name" header="Name" sortable />
                    <Column field="account_Person_Email" header="Email" sortable />
                    <Column field="account_Person_Desk" header="Desk No." />
                    <Column field="account_Person_Cell" header="Cell No." sortable />
                    <Column field="addedBy" header="Added By" />
                    <Column field="added_On" header="Added On" body={(rowData: IVendorAccountDetailsList) => {
                        let date;
                        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} />

                    <Column body={actionBodyTemplate} />
                </DataTable>
            </Dialog>
        </>
    );
}